import React, { useRef, useState, useEffect } from 'react'
import Header from '../../Components/Header'
import { Col, Container, Row } from 'react-bootstrap'
import Sidebar from '../../Components/Sidebar'
import { useSelector, useDispatch } from 'react-redux'
import { toastAlert } from "../../lib/toastAlert";

import Totalnft from "../../assets/images/totalnft.png";
import Totalnft2 from "../../assets/images/totalnft2.png";
import Totalnft3 from "../../assets/images/totalnft3.png";
import Totalnft4 from "../../assets/images/totalnft4.png";
import Totalnft5 from "../../assets/images/totalnft5.png";
import Totalnft6 from "../../assets/images/totalnft6.png";
import Totalnft7 from "../../assets/images/totalnft7.png";

import { gettokencount } from '../../actions/users';
import { useNavigate } from 'react-router-dom';

function Dashboard() {
  const navigate = useNavigate()
  const switcher = useSelector(state => state?.reducer?.switcher)

  const[userdata,setuserdata]=useState(0)
  const [tokenCount, settokenCount] = useState(0);
  const [tranCount, settranCount] = useState(0);
  const [ReportCount,setReportCount]=useState(0)


  useEffect(() => {
    gettokencounts();
  }, [])

  const gettokencounts =async () => {
    var test = await gettokencount();
     if (test.Success) {
    settranCount(test.transCount);
    setuserdata(test.userCountData)
    settokenCount(test.countData);
    setReportCount(test.reportcount)
  }
  else{
    toastAlert("error", "Error in Server")
  }
  }

  return (
    <>
      <Container fluid className='common_bg position-relative'>
        <div className='liner'></div>
        <Row>
          <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={'Dashboard'} switcher={switcher} />

            <div className='common_page_scroller mt-4 mt-sm-5 pe-2'>
              <Row className=''>
               
                    <Col lg={4} md={12} sm={6} className='mt-4 mb-4 mb-lg-0'>
                      <div className='dashboard_box p-3 rounded-3 d-flex align-items-center justify-content-between gap-4'>
                       <img src={Totalnft} className='img-fluid dashimg' alt='images'/>
                        <div className='text-end'>
                          <p className='text-white'>Total Nfts</p>
                          <h4 className='text-white mb-0'>{tokenCount.Total} NFT's</h4>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} md={12} sm={6} className='mt-4 mb-4 mb-lg-0'>
                      <div className='dashboard_box p-3 rounded-3 d-flex align-items-center justify-content-between gap-4'>
                       <img src={Totalnft2} className='img-fluid dashimg' alt='images'/>
                        <div className='text-end'>
                          <p className='text-white'>BEP-721 Standard</p>
                          <h4 className='text-white mb-0'>{tokenCount.NFT721} NFT</h4>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} md={12} sm={6} className='mt-4 mb-4 mb-lg-0'>
                      <div className='dashboard_box p-3 rounded-3 d-flex align-items-center justify-content-between gap-4'>
                       <img src={Totalnft3} className='img-fluid dashimg' alt='images'/>
                        <div className='text-end'>
                          <p className='text-white'>BEP-1155 Standard</p>
                          <h4 className='text-white mb-0'>{tokenCount.NFT1155} NFT</h4>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} md={12} sm={6} className='mt-4 mb-4 mb-lg-0'>
                      <div className='dashboard_box p-3 rounded-3 d-flex align-items-center justify-content-between gap-4'>
                       <img src={Totalnft4} className='img-fluid dashimg' alt='images'/>
                        <div className='text-end'>
                          <p className='text-white'>Total Users</p>
                          <h4 className='text-white mb-0'>{userdata} Users</h4>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} md={12} sm={6} className='mt-4 mb-4 mb-lg-0' onClick={()=>navigate('/purchasedlist')}>
                      <div className='dashboard_box p-3 rounded-3 d-flex align-items-center justify-content-between gap-4'>
                       <img src={Totalnft5} className='img-fluid dashimg' alt='images'/>
                        <div className='text-end'>
                          <p className='text-white'>Transactions</p>
                          <h4 className='text-white mb-0'>{tranCount} actions</h4>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} md={12} sm={6} className='mt-4 mb-4 mb-lg-0'>
                      <div className='dashboard_box p-3 rounded-3 d-flex align-items-center justify-content-between gap-4'>
                       <img src={Totalnft6} className='img-fluid dashimg' alt='images'/>
                        <div className='text-end'>
                          <p className='text-white'>Burned NFT's</p>
                          <h4 className='text-white mb-0'>{tokenCount.Burn} NFT</h4>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} md={12} sm={6} className='mt-4 mb-4 mb-lg-0'>
                      <div className='dashboard_box p-3 rounded-3 d-flex align-items-center justify-content-between gap-4'>
                       <img src={Totalnft7} className='img-fluid dashimg' alt='images'/>
                        <div className='text-end'>
                          <p className='text-white'>Pending Report's</p>
                          <h4 className='text-white mb-0'>{ReportCount} Reports</h4>
                        </div>
                      </div>
                    </Col>
              </Row>
            </div>
            <div>

            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Dashboard